import { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";
import Select from "react-select";
import { ecommerceapiUrl, adminlimit } from "../../Helpers/Config";
import { GET_LISTDATA } from "../../../actions";
import { showStatus, encodeValue, removeItem, checkingPermisson } from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "cateringeventtype";
var moduleName = "Event Type";
class List extends Component {
  constructor(props) {
    super(props);
    var companyID = cookie.load("companyID");
    this.state = {
      companyID: companyID,
      path: this.props?.location?.pathname || '',
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      loading: true,
      name: "",
      status: "",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }
  componentDidMount() {
    this.loadList(1);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }
  };
  removeItem(deleteID, e) {
    e.preventDefault();
    removeItem(deleteID, module, "client", this.sateValChange, this.state.currentPage, "ecom");
  }
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }

  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  loadList(offset) {
    var addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (this.state.status !== null && Object.keys(this.state.status).length > 0) {
      addParams += "&status=" + this.state.status.value;
    }

    var params = {
      params: "limit=" + adminlimit + "&offset=" + offset + addParams,
      url: ecommerceapiUrl + module,
      authType: "client",
    };
    this.props.getListData(params);
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        name: "",
        status: "",
      },
      function () {
        this.loadList(1);
      }
    );
  }

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"catering-event"} />
          <div className="layout-page">
            <Topmenu />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">{moduleName}</h4>
                  </div>
                  {checkingPermisson(["catalogs"], "add") && (
                    <div className="col-lg-2 col-md-6 text-end">
                      <Link to={this.state.path + "/add"}>
                        <button type="button" className="btn btn-outline-primary waves-effect">
                          Add New
                        </button>
                      </Link>
                    </div>
                  )}
                </div>
                <div className="row mb-4">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <input type="text" className="form-control" name="name" onChange={this.handleChangeText} value={this.state.name} />
                      <label htmlFor="name">Name</label>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                      <Select
                        value={this.state.status}
                        onChange={this.handleSelectChange.bind(this, "status")}
                        placeholder="Select Status"
                        isClearable={true}
                        options={[
                          { value: "A", label: "Active" },
                          { value: "I", label: "Inactive" },
                        ]}
                      />
                      <label className="select-box-label">Status</label>
                    </div>
                  </div>
                  <div className="col-md-3 mt-2">
                    <button type="button" className="btn btn-primary me-sm-3 me-1 waves-effect waves-light" onClick={this.searchList.bind(this)}>
                      Search
                    </button>
                    <button type="reset" className="btn btn-label-secondary waves-effect" onClick={this.resetSearch.bind(this)}>
                      Reset
                    </button>
                  </div>
                </div>

                <div className="card">
                  <div className={`${this.state.listdata.length >= 5 ? "table-responsive" : ""} text-nowrap p-1 mt-4`}>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Event Type Name</th>
                          <th>Status</th>
                          {(checkingPermisson(["catalogs"], "edit") || checkingPermisson(["catalogs"], "delete")) && <th>Actions</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading === true ? (
                          <tr>
                            <td colSpan={4} align="center">
                              <div className="spinner-border spinner-border-lg text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            </td>
                          </tr>
                        ) : this.state.listdata.length > 0 ? (
                          this.state.listdata.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <strong>{item.cateringEventTypeName}</strong>
                                </td>
                                <td>{showStatus(item.cateringEventTypeStatus)}</td>
                                {(checkingPermisson(["catalogs"], "edit") || checkingPermisson(["catalogs"], "delete")) && (
                                  <td>
                                    <div className="dropdown">
                                      <button type="button" className="btn p-0 dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
                                        <i className="mdi mdi-dots-horizontal"></i>
                                      </button>
                                      <div className="dropdown-menu">
                                        {checkingPermisson(["catalogs"], "edit") && (
                                          <Link to={this.state.path + "/edit/" + encodeValue(item._id)} className="dropdown-item">
                                            <i className="mdi mdi-pencil-outline me-1"></i>
                                            Edit
                                          </Link>
                                        )}
                                        {checkingPermisson(["catalogs"], "delete") && (
                                          <a className="dropdown-item" href="/" onClick={this.removeItem.bind(this, encodeValue(item._id))}>
                                            <i className="mdi mdi-trash-can-outline me-1"></i>
                                            Delete
                                          </a>
                                        )}
                                      </div>
                                    </div>
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={3}>
                              No {moduleName} Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagenation
                    params={{
                      totalRecords: this.state.totalRecords,
                      totalPage: this.state.totalPage,
                      currentPage: this.state.currentPage,
                    }}
                    sateValChange={this.sateValChange}
                  />
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = [];
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(List));
